import React from 'react';
import { useClient } from '@context/presentation';
import { useTranslation } from 'react-i18next';

export const SectionTwo = () => {
    const { t } = useTranslation();
    const { firm } = useClient();

    return (
        <>
        <h4>{t('modification.script.6')}</h4>
        <div>
            <strong style={{ textDecoration: 'underline'}}>
                {firm}
            </strong>
            {t('modification.script.7')}
        </div>
        <h4>{t('modification.script.8')}</h4>
        <div>
            {t('modification.script.9')}
            <strong style={{ textDecoration: 'underline'}}>
                {firm}
            </strong>
            {t('modification.script.10')}
        </div>
        <div>{t('modification.script.11')}</div>
        <div>
            <strong>{t('modification.script.12')}</strong>
        </div>
       </>
    );
};
